export default "__VITE_ASSET__QbVCBuX___";